import { render, staticRenderFns } from "./BottomView.vue?vue&type=template&id=d6524556&"
import script from "./BottomView.vue?vue&type=script&lang=js&"
export * from "./BottomView.vue?vue&type=script&lang=js&"
import style0 from "./BottomView.vue?vue&type=style&index=0&id=d6524556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports